import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import studentsImage from '../assets/racl_students.png';

export default function Newsletter(){

    // const newsletters = [
    //     {
    //         title: '2026春季第十六周上课校长通知',
    //         date: '2026-05-14',
    //         publisher: 'Xinjun Zhi',
    //         content: '尊敬的各位家长朋友们，\n\n本周六（01/24/2026）春季中文课程和所有课外活动课目前安排是正常上课，但请大家关注明天的最新更新。 如果中文学校明天收到APEX中学的通知确认，我们会及时通知大家。\n\n已经注册秋季中文课程的学生会自动注册春季的中文课程，但请家长登录系统确认。 课外活动课需要家长重新选择注册，请家长在本周五01/23晚11:59PM缴费截止，请及时完成付款，以免产生学费滞纳金30$。\n如果您需要注册服务，请周六到学校或者发邮件到 registration@racl.org。'
    //     },
    //     {
    //         title: '2026春季第十五周上课校长通知',
    //         date: '2026-05-07',
    //         publisher: 'Xinjun Zhi',
    //         content: '尊敬的各位家长朋友们，\n\n本周六（01/17/2026）春季中文课程和所有课外活动课目前安排是正常上课，但请大家关注明天的最新更新。 如果中文学校明天收到APEX中学的通知确认，我们会及时通知大家。\n\n已经注册秋季中文课程的学生会自动注册春季的中文课程，但请家长登录系统确认。 课外活动课需要家长重新选择注册，请家长在本周五01/16晚11:59PM缴费截止，请及时完成付款，以免产生学费滞纳金30$。\n如果您需要注册服务，请周六到学校或者发邮件到 registration@racl.org。'
    //     },
    //             {
    //         title: '2026春季第十四周上课校长通知',
    //         date: '2026-04-30',
    //         publisher: 'Xinjun Zhi',
    //         content: '尊敬的各位家长朋友们，\n\n本周六（01/17/2026）春季中文课程和所有课外活动课目前安排是正常上课，但请大家关注明天的最新更新。 如果中文学校明天收到APEX中学的通知确认，我们会及时通知大家。\n\n已经注册秋季中文课程的学生会自动注册春季的中文课程，但请家长登录系统确认。 课外活动课需要家长重新选择注册，请家长在本周五01/16晚11:59PM缴费截止，请及时完成付款，以免产生学费滞纳金30$。\n如果您需要注册服务，请周六到学校或者发邮件到 registration@racl.org。'
    //     },
    //             {
    //         title: '2026春季第十三周上课校长通知',
    //         date: '2026-04-23',
    //         publisher: 'Xinjun Zhi',
    //         content: '尊敬的各位家长朋友们，\n\n本周六（01/17/2026）春季中文课程和所有课外活动课目前安排是正常上课，但请大家关注明天的最新更新。 如果中文学校明天收到APEX中学的通知确认，我们会及时通知大家。\n\n已经注册秋季中文课程的学生会自动注册春季的中文课程，但请家长登录系统确认。 课外活动课需要家长重新选择注册，请家长在本周五01/16晚11:59PM缴费截止，请及时完成付款，以免产生学费滞纳金30$。\n如果您需要注册服务，请周六到学校或者发邮件到 registration@racl.org。'
    //     },
    //     {
    //         title: '22026春季第十二周上课校长通知',
    //         date: '2026-04-16',
    //         publisher: 'Xinjun Zhi',
    //         content: '尊敬的各位家长朋友们，\n\n本周六（01/17/2026）春季中文课程和所有课外活动课目前安排是正常上课，但请大家关注明天的最新更新。 如果中文学校明天收到APEX中学的通知确认，我们会及时通知大家。\n\n已经注册秋季中文课程的学生会自动注册春季的中文课程，但请家长登录系统确认。 课外活动课需要家长重新选择注册，请家长在本周五01/16晚11:59PM缴费截止，请及时完成付款，以免产生学费滞纳金30$。\n如果您需要注册服务，请周六到学校或者发邮件到 registration@racl.org。'
    //     }
    // ];

    const [newsContent, setNewsContent] = useState('');
    const [newsContent2, setNewsContent2] = useState('');

    useEffect(() => {
        // 
        // fetch('./language-class-intro.html') // Path relative to public folder
        fetch('./newsletters/reg-notice-2026.html') // Path relative to public folder
        .then(response => response.text())
        .then(data => setNewsContent(data));
    }, []);

    useEffect(() => {
        // 
        // fetch('./language-class-intro.html') // Path relative to public folder
        fetch('./newsletters/newsletter_20260827.html') // Path relative to public folder
        .then(response => response.text())
        .then(data => setNewsContent2(data));
    }, []);

    return (

        <>
        <Box height={100} />

            <Grid container spacing={0} alignItems="left" justify="left">
                <Grid item xs={2} />
                <Grid item xs={8}>
                                        <Card>
                        <CardHeader title='三角区中文学校校长信息 （TriCLS Principal Messages）'/>
                        <CardContent>
                            <Box textAlign={'left'}>
                                
                                <Grid container spacing={2} alignItems="left" justify="left">
                                    <Grid item xs={2}>
                                        <Typography>
                                            08/27/2026
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography >
                                            by 王雪艳 (2026-2027 Principal)
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} />
                                </Grid>
                            </Box>



                            <Box textAlign={'left'} paddingTop={2}>
                                <div dangerouslySetInnerHTML={{ __html: newsContent2 }} />
                            </Box>

                        </CardContent>
                    </Card>
                    <br />
                    <Card>
                        <CardHeader title='TriCLS 2026-2027 学年注册通知'/>
                        <CardContent>
                            <Box textAlign={'left'}>
                                
                                <Grid container spacing={2} alignItems="left" justify="left">
                                    <Grid item xs={2}>
                                        <Typography>
                                            08/12/2026
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography >
                                            by 王雪艳 (2026-2027 Principal)
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} />
                                </Grid>
                            </Box>



                            <Box textAlign={'left'} paddingTop={2}>
                                <div dangerouslySetInnerHTML={{ __html: newsContent }} />
                            </Box>

                        </CardContent>
                    </Card>

                        {/* {newsletters.map((newsLetter) => (

                            <Card>
                                <CardHeader title={newsLetter.title}/>
                                <CardContent>

                                    <Box textAlign={'left'}>
                                        <Grid container spacing={2} alignItems="left" justify="left">
                                            <Grid item xs={2}>
                                                <Typography>
                                                    {newsLetter.date}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography>
                                                    by {newsLetter.publisher}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8} />
                                        </Grid>
                                    </Box>

                                    <Box textAlign={'left'} paddingTop={2}>
                                        <Typography>
                                            {newsLetter.content}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>

                        ))}  */}


                </Grid> 
                <Grid item xs={2} />
            </Grid>
            
            <Box height={80} />

</>

    );
}